import Button from 'components/Button.jsx';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'hooks/useTheme';
import OpenDoorAnimated from 'Icons/OpenDoor.jsx';
import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';

const ImageCard = ({
  imageSrc,
  titleItalic,
  titleGrotesk,
  description,
  className = '',
  imageHeight,
  imageWidth,
  cardWidth,
  showVector = false,
  buttonText,
  buttonLink,
  imageUrl,
  buttonVariant = 'dark',
  imgClassName = '',
  link,
  linkLabel,
  // 'inline' (default): original space-separated "01 Title" look.
  // 'grid': two-column layout (fixed-width number column) used by ThinImagesSection.
  titleLayout = 'inline',
}) => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`flex flex-column full-width image-card full-height ${className}`}
      style={{ ...(cardWidth && { width: cardWidth }) }}
    >
      <img
        src={imageUrl || imageSrc}
        alt={titleItalic || titleGrotesk}
        className={`full-width ${imgClassName}`}
        style={{
          ...(imageHeight && { height: imageHeight }),
          ...(imageWidth && { width: imageWidth }),
        }}
      />
      <div className='image-card-content'>
        <div>
          <div className='row-gap-16 flex flex-column'>
            {showVector && <span className='full-width vector' />}
            <p
              className={`title ${titleLayout === 'inline' ? 'font-secondary' : ''}`}
            >
              {titleLayout === 'grid' ? (
                <>
                  <span className='title-index font-secondary'>
                    {renderWithLineBreaks(titleItalic)}
                  </span>
                  <span className='title-label font-primary'>
                    {renderWithLineBreaks(titleGrotesk)}
                  </span>
                </>
              ) : (
                <>
                  {renderWithLineBreaks(titleItalic)}{' '}
                  <span className='font-primary'>
                    {renderWithLineBreaks(titleGrotesk)}
                  </span>
                </>
              )}
            </p>
          </div>
        </div>
        {description && <p className='description-text'>{description}</p>}
        {link && (
          <a
            href={link}
            target='_blank'
            rel='noopener noreferrer'
            className='team-member-link'
          >
            {linkLabel}
            <OpenDoorAnimated
              color={isDarkMode ? '#ffffff' : 'rgba(21, 41, 48, 1)'}
              verticalAlign='center'
            />
          </a>
        )}
        {buttonText && buttonLink && (
          <Button
            variant={buttonVariant}
            showIcon={true}
            onClick={() => navigate(buttonLink)}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ImageCard;
